export const RESUMO_DECLARACAO_OPERACAO_IMOBILIARIA = [
  {
    "id": "CE2016080000000012016",
    "tipoDeclaracao": "Normal",
    "tipoOperacao": "ALIENANTE",
    "controle": 1,
    "recibo": null,
    "dataAlienacao": "2016-12-23T02:00:00.000+00:00",
    "valorAlienacao": 1000000,
    "cnpjCartorio": "13450002000124",
    "participantes": 4
  },
  {
    "id": "CE2017080000000012017",
    "tipoDeclaracao": "Normal",
    "tipoOperacao": "ADQUIRENTE",
    "controle": 1,
    "recibo": null,
    "dataAlienacao": "2017-01-17T02:00:00.000+00:00",
    "valorAlienacao": 100000,
    "cnpjCartorio": "13450002000124",
    "participantes": 2
  }
];
